import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Layout from '../components/Layout';

const NotFoundPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '404 — Page Not Found | InfyniHub';
  }, []);

  return (
    <Layout>
      <Box sx={{ bgcolor: '#FFFFFF', pt: { xs: '140px', md: '150px' }, minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
        <Container maxWidth="sm" sx={{ px: { xs: 3, md: 4 }, textAlign: 'center' }}>
          <Typography sx={{ fontSize: { xs: '5rem', md: '8rem' }, fontWeight: 900, color: '#EEF2FF', lineHeight: 1, mb: 2, letterSpacing: '-0.04em' }}>
            404
          </Typography>
          <Typography sx={{ fontWeight: 900, color: '#0F1117', fontSize: { xs: '1.6rem', md: '2rem' }, letterSpacing: '-0.02em', mb: 2 }}>
            Page not found
          </Typography>
          <Typography sx={{ color: '#6B7280', lineHeight: 1.8, mb: 5, fontSize: '0.95rem' }}>
            The page you're looking for doesn't exist or has been moved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              onClick={() => navigate('/')}
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              sx={{ bgcolor: '#6366F1', color: '#fff', px: 4, py: 1.4, fontWeight: 700, borderRadius: '8px', textTransform: 'none', boxShadow: '0 4px 20px rgba(99,102,241,0.3)', '&:hover': { bgcolor: '#5254CC' } }}
            >
              Back to Home
            </Button>
            <Button
              onClick={() => navigate('/blogs')}
              sx={{ color: '#6366F1', border: '1px solid #C7D2FE', px: 4, py: 1.4, fontWeight: 700, borderRadius: '8px', textTransform: 'none', '&:hover': { bgcolor: '#EEF2FF' } }}
            >
              Read our Blog
            </Button>
          </Box>
        </Container>
      </Box>
    </Layout>
  );
};

export default NotFoundPage;
